import { configureStore } from '@reduxjs/toolkit';
import { logger } from 'redux-logger';
import { visitorReducer } from '../features/visitors/visitorSlice';
import { userReducer } from '../features/users/userSlice';
import { campReducer } from '../features/camp/campSlice';


export const store = configureStore({
  reducer: {
    visitors: visitorReducer,
    user: userReducer,
    camp: campReducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat([logger])
});
